export default [
  { label: 'ID', field: 'id', sortable: true, textAlign: 'left', isImportant: true },
  { label: 'Código', field: 'code', sortable: true, textAlign: 'left', isImportant: true },
  { label: 'Fecha Transacción', field: 'checkout', sortable: true, textAlign: 'left' },
  { label: 'Monto', field: 'total', sortable: true, textAlign: 'left', isMoney: true },
];
